<div class="h-screen overflow-hidden flex relative bg-surface-50">
  <div
    class="h-screen bg-surface-0 shrink-0 left-0 top-0 z-10 border-r border-surface-200 w-[70px] select-none"
  >
    <app-sidebar></app-sidebar>
  </div>
  <div class="h-full flex flex-col flex-auto overflow-hidden">
    <router-outlet></router-outlet>
  </div>
</div>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
